/* app/js/src/components/calendar/replace-show/common/attention-popup.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  color: #232f3a;
}
div .attention {
  color: red;
  text-align: center;
}
div .explanation {
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 400;
}
div .actions .option {
  color: #879baf;
}
div .actions .option label {
  cursor: pointer !important;
}
div .actions .option.selected {
  color: #232f3a !important;
  font-weight: 700;
}
/*# sourceMappingURL=attention-popup.component.css.map */
